<script setup lang="ts">
import { PersonData, OtherCondition, PrescribedConditionTypes } from "@/entities/conditions";
import MedicalFormBuilder from "@/components/medicalConditionForms/MedicalFormBuilder.vue";
import { parseSchema } from "@/components/medicalConditionForms/schema";
import { useMedicalForm } from "../useMedicalForm";

import other from "./other.json";

export interface Props {
    condition: OtherCondition,
    personDetails: PersonData
}

const props = defineProps<Props>();

const emit = defineEmits<{
        (on:"update:condition", value: OtherCondition): void
    }>();

const { onConditionUpdate, state } = useMedicalForm<{type: PrescribedConditionTypes.Other} & OtherCondition>({
    ...props.condition,
    type: PrescribedConditionTypes.Other,
    medications: props.condition.medications || [],
    diagnosis_date: props.condition.diagnosis_date || "",

}, emit);
</script>

<template>
    <MedicalFormBuilder
        :diagnosis-date="state.condition.diagnosis_date"
        :schema="parseSchema(other)"
        :initial-form="state.condition"
        :person-details="props.personDetails"
        @update:form="onConditionUpdate"
    />
</template>
